<main>
  <div class="container">

    <div class="row mb-3">
      <div class="col general-title blue">
        <h2>Siga o seu Plano</h2>
      </div>
    </div>

    <div class="box table-responsive mb-4">
      <table class="table table-borderless table-hover">
        <thead>
          <tr>
            <th class="aviso">Aviso</th>
            <th class="text-center px-2 px-md-5">Data de envio</th>
          </tr>
        </thead>
        <tbody>
          @for (item of avisos; track item) {
            <tr (click)="openModalAViso(item); modalAviso.init(item)" style="cursor: pointer;">
              <td>
                <h4 class="title">{{item.TITULO}}
                  @if (item.COD_ARQ_GRUPO!=null) {
                    <span><i style="color: #848484;" class="fas fa-paperclip"></i></span>
                  }
                </h4>
                <p>{{ (item.DESCRICAO.length>6)? (item.DESCRICAO | slice:0:360)+'..': (item.DESCRICAO) }}</p>
              </td>
              <td class="text-center date px-2 px-md-5">
                {{item.TIM_HAB_INICIO| date:"dd/MM/yyyy HH:mm:ss"}}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="text-center">
      @if (avisos.length >= numAviPagina && temMais && avisos.length > 0) {
        <button type="button" class="btn btn-link" (click)="carregarMais()">Carregar Mais</button>
      }
    </div>

  </div>

  <app-modal-siga-seu-plano #modalAviso (onModalClose)="onCloseModalAviso()" modalID="modalSigaSeuPlanoNot"></app-modal-siga-seu-plano>
</main>